import React from 'react';
import { Header } from '../components/Layout/Header';
import { BarChart2, TrendingUp, Clock } from 'lucide-react';

export function ReportsPage() {
  return (
    <div>
      <Header title="Relatórios" />
      <div className="p-6">
        <div className="text-center py-16">
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <BarChart2 size={28} className="text-primary-500" />
          </div>
          <h3 className="text-lg font-medium text-gray-900">Relatórios e Análises</h3>
          <p className="text-gray-500 mt-1 max-w-md mx-auto">
            Recursos avançados de relatório, incluindo gráficos de burndown, rastreamento de velocidade e análises de produtividade, estarão disponíveis em breve.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8 max-w-2xl mx-auto text-left">
            {[
              { icon: TrendingUp, title: 'Gráfico de Burndown', desc: 'Acompanhe o progresso do sprint ao longo do tempo' },
              { icon: BarChart2, title: 'Velocidade', desc: 'Métricas de desempenho da equipe' },
              { icon: Clock, title: 'Controle de Tempo', desc: 'Horas estimadas vs. reais' },
            ].map(({ icon: Icon, title, desc }) => (
              <div key={title} className="bg-white border border-gray-200 rounded-xl p-4">
                <Icon size={20} className="text-primary-500 mb-2" />
                <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
                <p className="text-xs text-gray-500 mt-1">{desc}</p>
                <span className="text-xs text-primary-500 mt-2 inline-block">Em breve</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
